<app-past-purchase-title-mobile *ngIf="item.pastPurchaseInfo && source !== 'pastPurchase' && source !== 'buyerOFFers'" [item]="item"></app-past-purchase-title-mobile>

<div class="item" [class._details-opened]="isDetailsOpened" [class.similar-expanded]="item?.similar?.expanded"
[ngClass]="{
  '__purchased': item.pastPurchaseInfo && source !== 'pastPurchase' && source !== 'buyerOFFers',
  '__grading-border': item.pastPurchaseInfo && source == 'pastPurchase' || item.quantitySold && item.quantitySold && source == 'justSold'
}">
  <!-- Past Purchase start -->
  <div class="item-additional _past-purchase" *ngIf="item.pastPurchaseInfo && source == 'pastPurchase'">
    <div class="item-additional-wrap">
      <div class="item-additional-header">
        Past Purchase #{{ item.pastPurchaseInfo.documentNumber }}
      </div>
      <div class="item-additional-date">
        {{ item.pastPurchaseInfo.purchaseDate | date:'shortDate' }}
      </div>
      <div class="item-additional-values">
        <div class="item-additional-value">
          <div class="item-additional-value__name">Total Units</div>
          <div class="item-additional-value__value">{{ item.pastPurchaseInfo.quantitySold }}</div>
        </div>
        <div class="item-additional-value">
          <div class="item-additional-value__name">Purchase Price</div>
          <div class="item-additional-value__value">{{ item.pastPurchaseInfo.priceSold | currency:'USD':'symbol-narrow' }}</div>
        </div>
        <div class="item-additional-value">
          <div class="item-additional-value__name">Total</div>
          <div class="item-additional-value__value">{{ item.pastPurchaseInfo.priceSold * item.pastPurchaseInfo.quantitySold |
            currency:'USD':'symbol-narrow' }}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- Past Purchase end -->

  <!-- Just sold start -->
  <div class="item-additional _just-sold" *ngIf="item.quantitySold && item.quantitySold && source == 'justSold'">
    <div class="item-additional-wrap">
      <div class="item-additional-header">
        Just Sold!
      </div>
      <div class="item-additional-values">
        <div class="item-additional-value">
          <div class="item-additional-value__name">Units Sold</div>
          <div class="item-additional-value__value">{{item.quantitySold}}</div>
        </div>
        <div class="item-additional-value">
          <div class="item-additional-value__name">Unit Price</div>
          <div class="item-additional-value__value">{{item.priceSold | currency:'USD':'symbol-narrow'}}</div>
        </div>
        <div class="item-additional-value">
          <div class="item-additional-value__name">Total</div>
          <div class="item-additional-value__value">{{item.priceSold * item.quantitySold | currency:'USD':'symbol-narrow'}}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- Just sold start -->

  <!-- Notification date start -->
  <div class="item-notification-date" *ngIf="currentNotFilter === NotificationFiltersEnum">
    <div class="item-notification-date__value">{{ item.lastNotificationDate | date: 'MMM d, y' }}</div>
  </div>

  <ng-template ngFor let-details [ngForOf]="item.notificationDetails">
    <div class="item-notification-date" *ngIf="details.notificationType === getNotificationType(currentNotFilter)">
      <div class="item-notification-date__value">{{ details.timeStamp | date: 'MMM d, y' }}</div>
    </div>
  </ng-template>
  <!-- Notification date end -->

  <div *ngIf="item.gradingGuideUrl" (click)="showGradingGuide($event)" class="item-grading">Grading Guide</div>

  <div class="item-btm-layout" (click)="toggleDetails($event, true)">
    <div class="item-details">

      <div *ngFor="let attribute of item.attributes" class="item-details-row">
        <ng-container *ngIf="attribute.label !== 'Packaging'">
          <div class="item-details-row__icon">
            <svg *ngIf="attribute.label==='Price Drop'" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="m10.6712861 3.13274794v8.48762466c0 .1868603-.1058659.2307439-.2364581.0976556 0 0-1.07821477-1.0982979-1.47623663-1.5088114-1.25248847-1.27630402-3.13138727.6383213-1.87889877 1.9146254l4.1125837 4.1187729c.4593082.4579519 1.2017259.4556816 1.6579731-.0048053l4.070058-4.1139676c1.2524885-1.2763041-.6264103-3.19092942-1.8912747-1.901867-.3869588.3989174-1.464571 1.4964728-1.464571 1.4964728-.131032.1335329-.2360799.0889459-.2360799-.0980769v-8.48766201c0-.74534782.5849065-1.23181036 1.3064254-1.08411902 0 0-.4071536-.11393589.0258974.00712936 4.2312922 1.1829152 7.3392954 5.11815114 7.3392954 9.79046577 0 5.607797-4.4771525 10.1538148-10 10.1538148s-10-4.5460178-10-10.1538148c0-4.66409569 3.09707837-8.59370351 7.3169763-9.78419772.4399767-.12412375.04810233-.01320354.04810233-.01320354.71982497-.15930334 1.30620747.33753352 1.30620747 1.083964z" fill="#80CB5E" fill-rule="evenodd"/>
            </svg>

            <svg *ngIf="attribute.label==='Today\'s Deals'" width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="doorbuster-24x24-white" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path d="M5.65288161,22.1989497 C6.65918683,23.0365017 7.82650089,23.6347532 9.07431937,23.9139372 C9.195076,23.9538206 9.27558042,23.7942869 9.195076,23.7145201 C6.498178,21.1220971 8.79255391,17.492705 9.27558042,16.7748033 C9.75860692,16.0170181 10.9661732,14.6609815 10.8856688,12.66681 C10.8856688,12.4673928 11.0869298,12.3078591 11.2479387,12.4275094 C12.7775226,13.225178 13.82408,14.9800489 14.1058455,16.4158524 C14.5486198,15.9771347 14.7096286,15.2991164 14.7096286,14.7008649 C14.7096286,14.5014478 14.9511419,14.341914 15.1524029,14.5014478 C16.6014824,15.8176009 19.0971194,20.2845451 15.0718985,23.7942869 C14.9913941,23.8740538 15.0718985,24.0335875 15.1524029,23.9937041 C16.3599692,23.6746366 17.5272832,23.1162686 18.5335885,22.3584834 C25.0946985,17.2534044 20.8279644,8.19986583 18.050562,5.20860859 C17.6882921,4.84965773 17.0442567,5.0889583 17.0442567,5.60744289 C17.0040045,6.6842955 16.6819869,7.8807984 15.8366905,8.67846699 C15.1926551,5.96639376 13.0592881,2.57630222 10.0001202,1.06073189 C9.59759809,0.861314739 9.11457158,1.18038218 9.15482379,1.61909991 C9.23532821,5.32825888 6.82019567,8.00044869 4.7270808,11.0714728 C2.87547919,13.8234294 1.66791293,18.888625 5.65288161,22.1989497 Z" id="Path" fill="#FFFFFF" fill-rule="nonzero" opacity="0.50999999"></path>
                </g>
            </svg>

            <svg *ngIf="attribute.label==='Just Launched'" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="m4.82286086 11.2536583 2.22796607.9320718c-.25120368.6398449-.45158379 1.2988286-.59924604 1.9707216l-.08450906.3875558 3.19405825 3.2244648.38413209-.0833245c.66595723-.1489784 1.31911933-.3511445 1.95331163-.6045872l.9238377 2.247824c.0183916.0452548.0581121.0781408.1056939.0875078.0475817.009367.0966423-.0060415.1305473-.0410011l1.3963201-1.4087655c.4608137-.4648659.7050426-1.1048168.6722311-1.7614414l-.0499371-.9049429c2.5852089-1.9261527 5.2011483-5.30370198 5.9137134-11.1984266.0409661-.29958284-.0590665-.60128253-.2704549-.81569559-.2113885-.21441307-.5098851-.31694489-.8070356-.27721194-5.8407283.72472946-9.1903601 3.36592264-11.09949651 5.96642246l-.89502775-.0465067c-.6493832-.0356489-1.28347095.20715647-1.74588031.66853385l-1.39632011 1.40876552c-.03938129.0337779-.05780582.0862546-.04828012.1375111.0095257.0512566.04554123.0934347.09437596.1105247zm8.95796014-3.43374493c.6756757-.67933509 1.7690696-.6780583 2.4431848.00285297.6741153.68091127.6741153 1.78405139 0 2.46496266-.6741152.6809113-1.7675091.6821881-2.4431848.002853-.3254733-.32723608-.5084175-.77174712-.5084175-1.23533433s.1829442-.90809825.5084175-1.2353343zm-9.37474344 10.20628353c-.36972195-.130904-.76674905-.1629492-1.15239625-.0930134-.06966958.0152038-.14219665-.0067482-.19206604-.0581334-.06230224-.0626108-.07918273-.1578293-.04225453-.2383468.40910067-.8875029 1.4942738-2.6721977 3.45910939-1.2304899.02075897.0187475.03262299.0455266.03262299.0736357 0 .028109-.01186402.0548881-.03262299.0736356-.53349089.4238836-.8351583 1.0786451-.81243935 1.7633791.00296577.0822048.06833297.1481546.14981151.1511468.67574202.0274108 1.32429609-.2702755 1.74780097-.8022406.01860333-.022981.04645659-.0363127.07586609-.0363127s.05726276.0133317.07586609.0363127c.27273377.3274847 1.02371199 1.3971389.19206604 2.4299752-.36306683.4402655-.88327531.7186979-1.44817795.7751117-.80667737.0872001-2.29710984.3526759-2.90595919 1.054152-.04979966.0595295-.12803333.086572-.20355322.0703607-.0755199-.0162113-.13606536-.0730444-.15753094-.1478719-.21511396-.7402317-.54930888-2.3950952 1.21385738-3.8213008z" fill="#EB3B44" />
            </svg>

            <img *ngIf="attribute.label==='Restrictions'" src="../../../../assets/images/new-item-details/restrictions.svg" width="24" height="24"/>
            <img *ngIf="attribute.label==='Warranty'" src="../../../../assets/images/new-item-details/Warranty.svg" width="24" height="24"/>
            <!-- <img *ngIf="attribute.label==='Packaging'" src="../../../../assets/images/new-item-details/Packaging.svg" width="24" height="24"/> -->
            <img *ngIf="attribute.label==='Condition'" src="../../../../assets/images/new-item-details/Condition.svg" width="24" height="24"/>
          </div>
          <div class="item-details-row__txt">
            <span *ngIf="attribute.label!=='Price Drop'&&attribute.label!=='Just Launched'&&attribute.label!=='Today\'s Deals'&&attribute.label!=='Visual Condition'">{{ attribute.label | currentDeal}}</span>
            <p *ngIf="attribute.value!=='Yes'&&attribute.label!=='Visual Condition'">{{ attribute.value }}</p>
            <p *ngIf="attribute.value==='Yes' && attribute.label !== 'Restrictions'&&attribute.label!=='Visual Condition'">{{ attribute.label | currentDeal}}</p>
            <p *ngIf="attribute.value==='Yes' && attribute.label === 'Restrictions'&&attribute.label!=='Visual Condition'">{{ attribute.description }}</p>
          </div>
        </ng-container>

        <ng-container *ngIf="attribute.label === 'Packaging'">
            <div class="item-details-row__icon">
              <img src="assets/images/new-item-details/Packaging.svg" alt="Packaging" width="24" height="24" />
            </div>

            <div class="item-details-row__txt" (click)="triggerPackageDescription($event)"  [class.package-descriptions]="itemsService.getPackageDescription(attribute.code)">
              <span class="label">{{ attribute.label | currentDeal }}</span>
              <p>
               
                {{ attribute.value }}
                <i><img src="assets/images/new-item-details/info.svg" alt="info"></i>
              </p>
              <span *ngIf="itemsService.getPackageDescription(attribute.code)" [class.show-description]="isShowPackageDescription" class="package-descriptions-tooltip" [innerHTML]="itemsService.getPackageDescription(attribute.code)">
              </span>
            </div>
        </ng-container>
      </div>

      <div *ngIf="item.leadTimeDays" class="item-details-row">
        <div class="item-details-row__icon">
          <img src="../../../../assets/images/new-item-details/eta.svg" width="24" height="24" />
        </div>
        <div class="item-details-row__txt">
          <p *ngIf="item.leadTimeDays">{{ item.leadTimeDays }} Days</p>
        </div>
      </div>

      <div *ngIf="item.comments[0]" class="item-details-row">
        <div class="item-details-row__icon">
          <img src="../../../../assets/images/new-item-details/24-info.svg" width="24" height="24" />
        </div>
        <div class="item-details-row__txt">
          <p> <span>More info:</span> {{ item.comments[0]?.comment }}</p>
        </div>
      </div>

    </div>
  </div>

  <div class="item-top-layout"
  (swipeleft)="hideDetails()"
  (swiperight)="showDetails()"
  >
    <div class="item-top">
      <div class="item-top__left">
        <div class="item-logo" (click)="toggleDetails($event, false)">
          <img [src]="item.manufacturerLogoUrl" alt="">
        </div>
        <div class="item-exw">
          <div class="item-exw__label">EXW</div>
          <div class="item-exw__value">{{ item.exwPoint }}</div>
        </div>
      </div>
      <div class="item-top__right">
        <div class="item-attribute-list" *ngIf="isTopAttributes(item.attributes)">
          <ng-container *ngFor="let attribute of item.attributes">
            <div class="item-attribute" *ngIf="attribute.label === 'Price Drop'" >
              <img src="../../../../assets/images/icons/mobile/24-price-drop.svg" alt="price drop">
            </div>
            <div class="item-attribute" *ngIf="attribute.label === 'Just Launched'">
              <img src="../../../../assets/images/icons/mobile/24-just-lauched.svg" alt="just lauched">
            </div>
            <div class="item-attribute" *ngIf="attribute.label === 'Today\'s Deals'">
              <img src="../../../../assets/images/icons/item-filter/doorbuster-24-dark.svg" alt="Doorbuster Deal">
            </div>
          </ng-container>
        </div>
        <div class="item-notifications" *ngIf='item.inventory.availableToSell>0'>
          <span
          (click)="userService.isGuest?userService.guestPop():openNotificationTooltip($event)"
          [class._active]="item.notificationInfoObj?.moreInventoryInitialValue || item.notificationInfoObj?.priceDropInitialValue" class="icon">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <linearGradient id="a" x1="74.588658%" x2="16.243437%" y1="17.361718%" y2="82.294216%"><stop offset="0" stop-color="#fe563b"/><stop offset="1" stop-color="#d8214d"/></linearGradient>
              <path class="icon-path" d="m13.78 19.7181605c0 1.0499261-.8554974 2.2818395-1.9 2.2818395h-.76c-1.0445026 0-1.9-1.2319134-1.9-2.2818395zm-7.3234555-11.87516484c.3382199-6.08957172 3.43591623-5.84158916 5.0434555-5.84158916l.0859603-.00019339c1.6294207-.0065559 4.625209-.1408844 4.9574952 5.84578227.2805236 5.08564232 4.0208377 8.28541732 4.0208377 8.28541732.2595818.2489958.4153299.5878449.4357068.9479333v.9199353c-.0032625.316075-.2585269.570883-.5729843.5719598v.0039997h-17.85403141c-.31599725-.0010972-.57189275-.2583214-.57298429-.5759595v-.923935c.02017979-.3601379.17595983-.6990563.43570681-.9479334 0 0 3.74031413-3.1937753 4.02083769-8.28541724z" fill="url(#a)"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
    <div class="item-desc">
      <span (click)="toggleDetails($event, false)">{{ item.description }}</span>
        <span *ngFor="let attribute of item.attributes" [ngClass]="{'hide': attribute.label!=='Condition'}">
           - {{ attribute.value }} - </span>
        <span class="copy-number"
        (click)=itemsService.copyText($event,item.partNumber)>{{item.partNumber}}
        <span ngModel="copied" ngDefaultControl>
          {{ itemsService.copied }}
        </span>
      </span>
    </div>
    <div class="item-prices">
      <div class="item-prices-item" *ngFor="let prices of item.prices">
        <div class="item-prices-item__qty">{{ prices.fromQty }}+</div>
        <div class="item-prices-item__price">{{ prices.unitPrice | CustomCurrency }}</div>
      </div>
    </div>
    <div class="item-btm">
      <div class="item-btm__left">
        <div class="item-price">
          <div class="item-price__label">Price</div>
          <div class="item-price__value">{{ item.baseUnitPrice | CustomCurrency }}</div>
        </div>

        <div class="item-available" *ngIf="item.inventory.availableToSell<1">
          <div class="item-available__label">Available</div>
          <div *ngIf="item.inventory.availableToSell<1" class="item-available__value _bold">Sold Out</div>
        </div>

        <div class="item-available" *ngIf="item.inventory.availableToSell > 0">
          <ng-container *ngIf="itemsService.showInStockTitle(item,sessionService.userRole)">
            <div class="item-available__label">In Stock</div>

            <div class="item-available__value" [class.has-similar]="item.similar?.hasSimilar && (item.availabilityPerSku?.onHand ?? 0) > 0"> 
              {{ itemsService.showInStockValue(item) }} 
              <ng-container *ngIf="item.similar?.hasSimilar && (item.availabilityPerSku?.onHand ?? 0) > 0">
                <span>
                  /{{ item.availabilityPerSku.onHand }}
                </span>
              </ng-container>
            </div>
          </ng-container>
          
          <ng-container *ngIf="itemsService.showInTransitTitle(item,sessionService.userRole)">
            <div class="item-available__label">In Transit</div>
            <div class="item-available__value" [class.has-similar]="item.similar?.hasSimilar && item.availabilityPerSku?.enRoute > 0">
              {{ itemsService.showInTransitValue(item) }}
              <ng-container *ngIf="item.similar?.hasSimilar && item.availabilityPerSku?.enRoute > 0">
                <span>
                  /{{ item.availabilityPerSku.enRoute }}
                </span>
              </ng-container>
            </div>
          </ng-container>
        </div>

      </div>

      <div class="item-btm__right">
        <div class="item-add-to-cart">
          <div class="item-add-to-cart__input-wrap">
            <input *ngIf="item.inventory.availableToSell>0"
                 type="text" class="item-add-to-cart__input" pattern="[0-9]*" inputmode="numeric"
                 [(ngModel)]="item.qty" (blur)="onBlur($event)"
                 [disabled]="topService.loading || item.added || !item.added && item.inventory.availableToSell<1"
                 [class.disabled]="item.added"
                 (click)="qtyInputClicked(qty)" #qty appOnlyDigits>
            <div class="item-add-to-cart__input-moq" *ngIf="item.moq > 1 || item.mxq > 0">
              <span *ngIf="item.moq > 1">MOQ {{ item.moq }}</span>
              <span *ngIf="item.mxq > 0">MXQ {{ item.mxq }}</span>
            </div>
          </div>

          <button *ngIf='!item.added && item.inventory.availableToSell>0' type="button" class="item-add-to-cart__btn"
                  (click)="!topService.loading?addToCart():''">
            <span class="icon" *ngIf="!item.loading">
              <img src="../../../../assets/images/icons/header/cart-white.svg" width="24" height="24" alt="cart">
            </span>
            <span *ngIf="item.loading" class="cart-loader __white"></span>
            <span class="text" *ngIf="!item.beingEdited && !item.loading">Add to Cart</span>
            <span class="text" *ngIf="!item.beingEdited && item.loading">Adding...</span>
            <span class="text" *ngIf="item.beingEdited && !item.loading">Update Cart</span>
            <span class="text" *ngIf="item.beingEdited && item.loading">Updating...</span>
          </button>

          <button *ngIf="item.added && item.inventory.availableToSell>0" (click)="!topService.loading?editItemQty():''" type="button" class="item-add-to-cart__btn _edit"  [class._delete-spinner]="deleteSpinner">
            <span *ngIf="item.loading || deleteSpinner" class="cart-loader __white"></span>
            <span *ngIf="!item.loading && !deleteSpinner">Edit QTY</span>
            <span *ngIf="item.loading && !deleteSpinner">Updating...</span>
            <span *ngIf="deleteSpinner">Deleting...</span>
          </button>
          <button *ngIf="item.added && item.inventory.availableToSell>0 && !deleteSpinner" type="button" class="item-add-to-cart__remove" (click)="removeItemFromCart()">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="m18 7.21-1.21-1.21-4.79 4.79-4.79-4.79-1.21 1.21 4.79 4.79-4.79 4.79 1.21 1.21 4.79-4.79 4.79 4.79 1.21-1.21-4.79-4.79z" />
            </svg>
          </button>
        </div>

        <div class="item-waitlist" *ngIf='item.inventory.availableToSell<1'>
          <button (click)="submitNotification()"
                  type="button" class="item-waitlist__btn"
                  [ngClass]="item.notificationInfoObj?.waitlist?'_waitlisted':'_add-to-waitlist'">
            <span class="icon">
              <img src="../../../../assets/images/icons/mobile/menu/24-bell-white.svg" width="24" height="24" alt="cart">
            </span>

            <span [class.hide]="item.notificationInfoObj?.waitlist" class="text">Add to Waitlist</span>
            <span [class.hide]="!item.notificationInfoObj?.waitlist" class="text">Waitlisted</span>
          </button>
        </div>

      </div>
    </div>
    <div *ngIf="displayMakeOfferBtn" class="item-offer">
        <a role="button" class="similar-button" (click)="toggleSimilar(item,$event)" *ngIf="item.similar?.hasSimilar">
          <i [class.hide]="item?.similar?.expanded">
            <svg height="12" width="12">
              <use xlink:href="#icon-plus"></use>
            </svg>
          </i>
          <i [class.hide]="!item?.similar?.expanded">
            <svg height="12" width="12">
              <use xlink:href="#icon-minus"></use>
            </svg>
          </i>
        </a>
        <a class="item-offer__button"
        (click)="openOfferModal()"
        [class.disabled]="offerService.makeOfferButtonDisabled(item)"
        [class.active]="offerService.offerMade(item)">
        <span class="_icon">
          <svg height="24" width="24">
            <use xlink:href="#icon-offers-listing"></use>
          </svg>
        </span>
       {{offerService.offerMade(item) ? 'Offer Made' : 'Make Offer'}}
      </a>
    </div>
  </div>
</div>
